import { render, staticRenderFns } from "./insertion-order-detail.vue?vue&type=template&id=44da35e4&scoped=true"
import script from "./insertion-order-detail.vue?vue&type=script&lang=js"
export * from "./insertion-order-detail.vue?vue&type=script&lang=js"
import style0 from "./insertion-order-detail.vue?vue&type=style&index=0&id=44da35e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44da35e4",
  null
  
)

export default component.exports